/* English Book Week, 12 t/m 25 oktober 2026.
   Legt The Baby Dragon Tulip Farm (cadeau) zelf in de winkelwagen zodra er voor
   minstens 14,99 aan Engelse boeken in zit, en haalt hem eruit als dat niet meer
   zo is. De korting die hem op 0 zet regelt Shopify; dit script zorgt alleen dat
   het boek er ligt. Leest de regels uit snippets/cart-regel.liquid (data-ebw).
   Haalt de klant het cadeau zelf weg, dan leggen we het deze sessie niet terug. */
(() => {
  'use strict';
  if (window.ebwCadeau) return;
  window.ebwCadeau = true;

  const CADEAU = 57636627710332;
  const DREMPEL = 1499;
  const VAN = Date.parse('2026-10-11T22:00:00Z');
  const TOT = Date.parse('2026-10-25T22:59:59Z');
  const WEG = 'ebw-cadeau-weg';

  const lees = (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
  const schrijf = (k, v) => { try { v ? sessionStorage.setItem(k, v) : sessionStorage.removeItem(k); } catch (e) {} };

  let bezig = false;

  const verversLade = async () => {
    if (location.pathname.replace(/\/$/, '').endsWith('/cart')) { location.reload(); return; }
    const data = await (await fetch('/cart.js')).json();
    document.querySelectorAll('[data-cart-count]').forEach((n) => {
      n.textContent = data.item_count;
      n.hidden = data.item_count === 0;
    });
    const res = await fetch(location.pathname + '?section_id=cart-drawer');
    const html = new DOMParser().parseFromString(await res.text(), 'text/html');
    ['[data-cart-body]', '[data-cart-foot]'].forEach((sel) => {
      const oud = document.querySelector(sel), nieuw = html.querySelector(sel);
      if (oud && nieuw) oud.innerHTML = nieuw.innerHTML;
    });
  };

  const kijk = async () => {
    if (bezig) return;
    const nu = Date.now();
    if (nu < VAN || nu > TOT) return;
    const body = document.querySelector('[data-cart-body]');
    if (!body) return;
    let totaal = 0;
    body.querySelectorAll('[data-ebw="boek"]').forEach((r) => { totaal += Number(r.dataset.ebwCent || 0); });
    const cadeau = body.querySelector('[data-ebw="cadeau"]');
    const recht = totaal >= DREMPEL;
    if (!recht) schrijf(WEG, '');
    let actie = null;
    if (recht && !cadeau && !lees(WEG)) actie = { add: true };
    else if (!recht && cadeau) actie = { key: cadeau.dataset.key, qty: 0 };
    else if (cadeau && Number(cadeau.dataset.ebwAantal) > 1) actie = { key: cadeau.dataset.key, qty: 1 };
    if (!actie) return;
    bezig = true;
    try {
      const opts = { method: 'POST', headers: { 'Content-Type': 'application/json' } };
      if (actie.add) {
        opts.body = JSON.stringify({ items: [{ id: CADEAU, quantity: 1 }] });
        const r = await fetch('/cart/add.js', opts);
        if (!r.ok) { schrijf(WEG, '1'); return; }
      } else {
        opts.body = JSON.stringify({ id: actie.key, quantity: actie.qty });
        await fetch('/cart/change.js', opts);
      }
      await verversLade();
    } catch (e) {
    } finally {
      bezig = false;
    }
  };

  document.addEventListener('click', (e) => {
    const weg = e.target.closest('[data-remove]');
    if (weg && weg.closest('[data-ebw="cadeau"]')) schrijf(WEG, '1');
  }, true);

  let wacht;
  const plan = () => { clearTimeout(wacht); wacht = setTimeout(kijk, 250); };
  const start = () => {
    const body = document.querySelector('[data-cart-body]');
    if (!body) return;
    new MutationObserver(plan).observe(body, { childList: true, subtree: true });
    plan();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();